import React from 'react'
import { useUniHelpdeskCharts } from '../../Hooks/Features/HelpDesk/useUniHelpdeskCharts';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import _ from "underscore";
import HighchartsReact from 'highcharts-react-official';
import Highcharts from "highcharts";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CommanDialog from '../CommonCompo/CommanDialog/CommanDialog';
import { SkeletonContainer } from '../Loader/Loader';
import { useCommon } from '../../Hooks/Common/useCommon';

const UniHelpdeskCharts = ({ chart, setChart, columns, rowData }) => {

    const {getValuePermission} = useCommon();
    const { createChart, setCreateChart, createOpts, loader, options, chartOpts, saveData, savedCharts, handleDelete, deleteChart, setDeleteChart } = useUniHelpdeskCharts({ chart, setChart, columns, rowData });

    return ( !getValuePermission("universal_helpdesk_chart_tab") &&
        <div>
            <div className='d-flex flex-wrap justify-content-evenly gap-4'>
                {loader?.chart ?
                    <div className='d-flex justify-content-evenly flex-wrap mt-4 w100' style={{ rowGap: "20px" }}>
                        {Array.from({ length: 2 }, (_, index) => (
                            <div style={{ width: "40%", height: "300px" }} key={index}><SkeletonContainer /></div>
                        ))}
                    </div>
                    : savedCharts?.map((chart) => (
                        <div className=" border d-flex flex-column" key={chart?.chart_configuration_id} style={{ width: `${chart?.chart_width}%`, height: (chart?.chart_height < 100 || chart?.chart_height === null) ? "300px" : `${chart?.chart_height}px` }}>
                            <div className='d-flex gap-1 justify-content-end' style={{ padding: '10px' }}>
                                <button onClick={() => { setChart(prev => ({ ...prev, visible: true })); setCreateChart((prev) => ({ ...prev, ...chart, width: chart?.chart_width, height: chart?.chart_height, chart_order: chart?.order_number })) }} className='sk-btn sk-btn-primary'><FontAwesomeIcon icon="fa-solid fa-pen-to-square" /></button>
                                <button className='sk-btn sk-btn-primary' onClick={() => { setDeleteChart((prev) => ({ ...prev, visible: true, data: chart })) }}><FontAwesomeIcon icon="fa-solid fa-trash" /></button>
                            </div>
                            {chart?.options && <HighchartsReact highcharts={Highcharts} options={chart?.options} />}
                        </div>
                    ))}
            </div>
            <Dialog visible={chart?.visible} onHide={() => { setChart(prev => ({ ...prev, visible: false })); setCreateChart({ width: "50", height: 300, chart_scope_key: "universal_helpdesk" }); }} draggable={false} className='modal-xlarge'>
                <div>
                    <div className="d-flex w100 justify-content-evenly align-items-center gap-3">
                        <div className='w15'>
                            <span className='bold'>Chart Name: </span>
                            <div><input type="text" placeholder='Enter Chart Name' className='sk-input-dd w100' value={createChart?.chartName} onChange={(e) => setCreateChart((prev) => ({ ...prev, chartName: e.target.value }))} /></div>
                        </div>

                        <div className='w20'>
                            <span className='bold'>Chart Type: *</span>
                            <Dropdown value={createChart?.chartType} options={createOpts?.chartOpts} optionLabel='chart_type_name' onChange={(e) => setCreateChart((prev) => ({ ...prev, chartType: e.target.value }))} placeholder='Select Chart Type' className='sk-input-dd' filter filterInputAutoFocus />
                        </div>

                        <div className='w20'>
                            <span className='bold'>X-Axis Column: *</span>
                            <Dropdown value={createChart?.xAxis} onChange={(e) => setCreateChart((prev) => ({ ...prev, xAxis: e.target.value }))} options={options?.xAxis} optionLabel='columnName' optionValue='key' placeholder='Select X-Axis' className='sk-input-dd' filter filterInputAutoFocus />
                        </div>

                        <div className='w15'>
                            <span className='bold'>Chart Width: (%)</span>
                            <div><input type="number" placeholder='Enter Width' className='sk-input-dd w100' value={createChart?.width} onChange={(e) => setCreateChart((prev) => ({ ...prev, width: e.target.value }))} /></div>
                        </div>

                        <div className='w15'>
                            <span className='bold'>Chart Height: (px)</span>
                            <div><input type="number" placeholder='Enter Height' className='sk-input-dd w100' value={createChart?.height} onChange={(e) => setCreateChart((prev) => ({ ...prev, height: e.target.value }))} /></div>
                        </div>

                        <div className='w15'>
                            <span className='bold'>Chart Order: </span>
                            <div><input type="number" placeholder='Enter Order' className='sk-input-dd w100' value={createChart?.chart_order} onChange={(e) => setCreateChart((prev) => ({ ...prev, chart_order: e.target.value }))} /></div>
                        </div>


                    </div>
                    {!_.isEmpty(createChart?.chartType) &&
                        <div className="highcharts-container d-flex justify-content-center mt-4">
                            <HighchartsReact highcharts={Highcharts} options={chartOpts} containerProps={{ style: { width: `${createChart?.width}%`, height: (parseInt(createChart?.height) < 100 || createChart?.height?.length === 0) ? "300px" : `${createChart?.height}px` } }} />
                        </div>
                    }
                    <div className='d-flex gap-2 justify-content-end mt-3'>
                        <button className='sk-btn sk-btn-primary' onClick={() => { setChart(false); setCreateChart(false); }}>Cancel</button>
                        {loader?.btn ? <button className='sk-btn sk-btn-primary bg-black text-white' style={{ width: "48px" }}>
                            <div className="spinner-border" role="status" style={{ width: "15px", height: "15px" }}>
                                <span className="sr-only"></span>
                            </div>
                        </button> :
                            <button className='sk-btn sk-btn-primary bg-black text-white' onClick={() => saveData()}>Save</button>}
                    </div>
                </div>
            </Dialog>

            <CommanDialog visible={deleteChart?.visible} handleClose={() => setDeleteChart({ visible: false, data: [] })} handleFun={async () => { await handleDelete({ ...deleteChart?.data, chart_scope_key: "universal_helpdesk" }); setDeleteChart({ visible: false, data: [] }) }} message="Are you sure you want to delete this chart?" />
        </div>
    )
}

export default UniHelpdeskCharts